import { latestList } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

export default function LatestSection() {
  return (
    <section id="latest" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="最新更新"
          title="同人导航目录新鲜事"
          desc="紧跟各平台的同人动态，第一时间整理最新连载与精选更新，不错过任何一部好作品。"
        />

        <div className="mx-auto flex max-w-4xl flex-col gap-3">
          {latestList.map((item, i) => (
            <article
              key={item.id}
              className="group flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3.5 transition-colors hover:border-primary-500/50"
            >
              <div className="flex items-center gap-3 sm:w-10">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-500/15 font-heading text-sm font-bold text-secondary-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-500">
                  {item.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-500">
                  {item.category} · {item.author} · {item.date}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="hidden sm:flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-fire-fill text-primary-500" /> {item.heat}
                </span>
                <span className="whitespace-nowrap rounded-full border border-primary-500/40 px-2.5 py-0.5 text-[11px] text-primary-500">
                  {item.tag}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}